import { render, staticRenderFns } from "./buyer-other-contacts.vue?vue&type=template&id=1e95848a"
import script from "./buyer-other-contacts.vue?vue&type=script&lang=js"
export * from "./buyer-other-contacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports